// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBa50cUVsQ_damg_mRwx65ODznsmwv0GSI',
  authDomain: 'baobab-2362d.firebaseapp.com',
  projectId: 'baobab-2362d',
  storageBucket: 'baobab-2362d.appspot.com',
  messagingSenderId: '166607235206',
  appId: '1:166607235206:web:ba21154d1facbd8b7c8907',
  measurementId: 'G-ZJE7C7G99S',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
